import api from "../../api/api";

export const getAllmasterModulesAPI = async (data) =>
  await api.get(`getAllModules/ppt/${data.usertype}/${data.language}`);

export const getAllsubmodulesAPI = async (data) =>
  await api.get(
    `getAllSubmodulesByModuleid/ppt/${data.usertype}/${data.language}/${data.moduleid}`
  );

export const getAllTopicsAPI = async (data) =>
  await api.get(
    `getAllTopicsBySubmoduleid/ppt/${data.usertype}/${data.language}/${data.moduleid}/${data.submoduleid}`
  );

export const getAllPptContentAPI = async (data) =>
  await api.get(
    `getContentsAndQuizByTopicid/${data.usertype}/${data.trainingType}/${data.moduleid}/${data.submoduleid}/${data.topicid}`
  );

export const updatePptContent = async (data) =>
  await api.put(`updateMasterContentQuizData`, data);

export const createPptContent = async (data) =>
  await api.put(`updateMasterContentQuizData`, data);

export const createQuizContent = async (data) =>
  await api.put(`updateMasterContentQuizData`, data);

//New
// export const getAllPptContentAPI = async (data) =>
//   await api.get(
//     `getContentsAndQuizByTopicid/${data.usertype}/ppt/${data.moduleid}/${data.submoduleid}/${data.topicid}`
//   );
